import { getTime } from 'date-fns/getTime';
import getReadableDateString from './getReadableDateString';
import getReadableDateTimeString from './getReadableDateTimeString';
import getReadableTimeString from './getReadableTimeString';
import { millisecondsToHours } from 'date-fns/millisecondsToHours';
import { millisecondsToMinutes } from 'date-fns/millisecondsToMinutes';
import { millisecondsToSeconds } from 'date-fns/millisecondsToSeconds';
import { minutesToMilliseconds } from 'date-fns/minutesToMilliseconds';
import { hoursToMilliseconds } from 'date-fns/hoursToMilliseconds';

const getTATStatus = (
  dateString: string
): {
  isExceeded: boolean | null;
  isDifferentDay: boolean | null;
  prefixString: string | null;
  suffixString: string | null;
  dateTimeString: string | null;
  dateString: string | null;
  timeString: string | null;
} => {
  if (!dateString) {
    return {
      isExceeded: null,
      isDifferentDay: null,
      prefixString: null,
      suffixString: null,
      dateTimeString: null,
      dateString: null,
      timeString: null,
    };
  }

  const readableDateTimeString = getReadableDateTimeString(dateString);
  const readableDateString = getReadableDateString(dateString);
  const readableTimeString = getReadableTimeString(dateString);

  let prefix = '';
  let suffix = '';
  const date = new Date(dateString);
  const currentDate = new Date();
  const delta = getTime(date) - currentDate.getTime();
  const isExceeded = delta < 0;
  let isDifferentDay = false;
  if (isExceeded) {
    prefix = 'Was expected by:';
    suffix = getReadableDateTimeString(dateString);
  } else {
    prefix = 'Estimated completion in';
    let hours = millisecondsToHours(delta);
    let minutes = millisecondsToMinutes(delta);

    // this will give the ms difference between the actual time and floored minutes
    const seconds = millisecondsToSeconds(
      delta - minutesToMilliseconds(minutes)
    );
    const shouldCeilMinutes = seconds >= 30;
    minutes = shouldCeilMinutes ? minutes + 1 : minutes;

    // minutes were ceiled and they went from 59 to 60 then ceil the hour
    if (shouldCeilMinutes && minutes % 60 === 0) {
      hours++;
    }

    const minutesInCurrentHour = millisecondsToMinutes(
      minutesToMilliseconds(minutes) - hoursToMilliseconds(hours)
    );

    const hoursText = `${hours} hour${hours > 1 ? 's' : ''}`;

    let minutesText = '';
    if (minutesInCurrentHour > 0) {
      minutesText = `${minutesInCurrentHour} minute${
        minutesInCurrentHour > 1 ? 's' : ''
      }`;
    }

    // the TAT is for next day or greater
    if (hours > 24) {
      isDifferentDay = true;
      prefix = 'Estimated completion:';
      suffix = readableDateTimeString;
    } else if (hours >= 1) {
      suffix = `${hoursText} ${minutesText}`;
    } else if (minutes > 1) {
      suffix = minutesText;
    } else if (minutes <= 1 && delta > 0) {
      suffix = '1 minute';
    }
  }

  return {
    prefixString: prefix,
    suffixString: suffix,
    isExceeded,
    isDifferentDay,
    dateTimeString: readableDateTimeString,
    dateString: readableDateString,
    timeString: readableTimeString,
  };
};

export default getTATStatus;
